<template>
  <div style="width: 100%; height: 100%">
    <p v-if="error" class="mb-4" style="color: red; font-weight: bold">
      {{ error }}
    </p>
    <div
      ref="cameraWrapper"
      class="round-camera"
      :class="{ 'is-mirrored': isFrontCamera }"
      :style="{
        width: '100%',
        height: error ? 'calc(100% - 42px)' : 'calc(100% - 4px)',
      }"
    >
      <qrcode-stream
        v-if="isCameraReady"
        @decode="onDecode"
        :camera="myCamera"
        @init="onInit"
        style="height: 100%; border-radius: 24px"
      >
        <div class="scan-center">
          <img
            src="@/assets/images/scan.svg"
            alt="scan-qr-code"
            style="width: 100%; height: 100%; position: absolute"
          />

          <v-chip small style="position: absolute; bottom: 5%">
            {{ $t("detailScanQrCode") }}
          </v-chip>
        </div>
        <div v-show="isLoading" class="scan-confirmation">
          <v-row class="d-flex align-center justify-center">
            <v-progress-circular indeterminate size="50" :color="site.color">
            </v-progress-circular>
          </v-row>
        </div>
      </qrcode-stream>
      <div
        v-else
        class="d-flex align-center justify-center"
        style="
          width: 100%;
          height: 100%;
          background-color: #eeeeee;
          border-radius: 24px;
        "
      >
        <v-icon>mdi-camera-off-outline</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import { mapState } from "vuex";

export default {
  emits: ["onDecode"],
  props: {
    camera: { default: "rear" },
    isReady: { default: false },
    isLoading: { default: false },
  },
  components: {
    QrcodeStream,
  },
  data() {
    return {
      error: "",
      myCamera: "rear",
      isFirstCameraReady: true,
      isCameraReady: false,
      isFrontCamera: false,
    };
  },
  async mounted() {},
  methods: {
    async onInit(promise) {
      try {
        const { capabilities } = await promise;
        if (this.isFirstCameraReady) {
          this.isFirstCameraReady = false;
          this.isCameraReady = false;
          setTimeout(() => {
            this.isCameraReady = true;
          }, 500);
        }

        // ไว้เช็คการ Mirror
        if (
          capabilities &&
          Array.isArray(capabilities.facingMode) &&
          capabilities.facingMode.length > 0
        ) {
          this.isFrontCamera = capabilities.facingMode.includes("user");
          return;
        }
        this.$nextTick(() => {
          const wrapperEl = this.$refs.cameraWrapper;
          const videoEl = wrapperEl ? wrapperEl.querySelector("video") : null;
          if (videoEl && videoEl.srcObject) {
            const videoTrack = videoEl.srcObject.getVideoTracks()[0];

            if (videoTrack) {
              const settings = videoTrack.getSettings
                ? videoTrack.getSettings()
                : {};

              if (settings.facingMode === "environment") {
                this.isFrontCamera = false;
                return;
              }
            }
          }
          this.isFrontCamera = true;
        });
      } catch (error) {
        console.log("error :>> ", error);
        this.isFrontCamera = false;
        if (error.name === "NotAllowedError") {
          this.error = this.$t("cameraError.notAllowed");
        } else if (error.name === "NotFoundError") {
          this.error = this.$t("cameraError.notFound");
        } else if (error.name === "NotSupportedError") {
          this.error = this.$t("cameraError.notSupported");
        } else if (error.name === "NotReadableError") {
          this.error = this.$t("cameraError.notReadable");
        } else if (error.name === "OverconstrainedError") {
          //   this.error = this.$t("cameraError.overconstrained");
          this.myCamera = "auto";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = this.$t("cameraError.streamApiNotSupported");
        } else if (error.name === "InsecureContextError") {
          this.error = this.$t("cameraError.insecureContext");
        } else {
          this.error = this.$t("cameraError.unknown", {
            error_name: error.name,
          });
        }
      }
    },
    async onDecode(result) {
      this.$emit("onDecode", result);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    isDesktop() {
      // เช็กว่าไม่ใช่ Mobile Device
      return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
  },
  filters: {},
  watch: {
    isReady: {
      handler() {
        this.isCameraReady = this.isReady;
      },
      deep: true,
      immediate: true,
    },
    camera: {
      handler() {
        this.myCamera = this.camera;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.is-mirrored :deep(video) {
  transform: scaleX(-1);
}
.round-camera :deep(video) {
  border-radius: 24px !important;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.scan-center {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>